import './_confirm-layouts.scss';
import Wrapper from './Wrapper';
import Title from './Title';
import Description from './Description';
import Actions from './Actions';
import TitleDescriptionWrapper from './TitleDescriptionWrapper';

export default {
  Wrapper,
  Title,
  Description,
  Actions,
  TitleDescriptionWrapper,
};
